module.exports = "/static/assets/aea5158bdd395199d39d9776f8d6e43c.png";